import shouldUseMonarchShortcuts from './shouldUseMonarchShortcuts';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    KeyboardShortcutsOptions,
} from 'owa-outlook-service-option-store';
import { default as WebKeyboardShortcutsMode } from 'owa-service/lib/contract/KeyboardShortcutsMode';
import type { MonarchKeyboardShortcutsMode } from 'owa-outlook-service-option-store';

export default function getKeyboardShortcutsMode():
    | WebKeyboardShortcutsMode
    | MonarchKeyboardShortcutsMode {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (17,5): Type 'MonarchKeyboardShortcutsMode | RecursiveReadOnly<KeyboardShortcutsMode | undefined>' is not assignable to type 'KeyboardShortcutsMode | MonarchKeyboardShortcutsMode'.
    // @ts-expect-error
    return shouldUseMonarchShortcuts()
        ? getOptionsForFeature<KeyboardShortcutsOptions>(OwsOptionsFeatureType.KeyboardShortcuts)
              .keyboardShortcutsMode
        : // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
          // -> Error TS2532 (23,11): Object is possibly 'undefined'.
          // @ts-expect-error
          getUserConfiguration().UserOptions.KeyboardShortcutsMode;
}
